import { apiGetHelper, apiPostHelper } from 'utils/apiHelper'
import { DOMAIN } from 'constants/base'
import { getCookie, isEmpty } from 'utils/browserHelper'
import { useQuery, useLazyQuery, useMutation } from '@apollo/client'
import { getPlatformApiDomain } from 'utils/uiHelper'
import { COUNTRY_MAP } from 'constants/domainConfig'

export const TripSuggestorApi = (...args) => {
    let url = `${DOMAIN}/offermgmt/popular_destinations/tripsuggester.json?trips=`
    const ARGS = [...args].join(',')
    const response = apiGetHelper(url + ARGS)
    return response
}

export const HotelOffer = () => {
    let url = `https://ui.cltp.co/landing/hotelsoffer/settings/in/json.js?v=${new Date().getTime()}`
    const response = apiGetHelper(url)
    return response
}

export const HotelsAutoSuggestApi = (str, context, searchPayload = false) => {
    const payLoad = {
        useCaseContext: context,
        prefix: str
    }
    if (searchPayload) {
        payLoad.filter = { ...searchPayload }
    }

    const requestHeaders = {
        'x-cookie': document && document.cookie
    }
    const domain = getPlatformApiDomain()
    const URL = `${domain}/prefixy/ui/autoSuggest/getSuggestions`
    const response = apiPostHelper(URL, payLoad, 'application/json', requestHeaders)
    return response
}

export const SearchByHotelsAutoSuggestApi = (str, fic, fcyIds) => {
    // const countryCode = COUNTRY_MAP[DOMAIN]
    const countryCode = 'IN'
    const requestHeaders = {
        'x-cookie': document && document.cookie
    }
    const domain = getPlatformApiDomain()
    const URL = `${domain}/hotels/auto-suggest/v3?c=${countryCode}&s=${str}&fic=${fic}&fcyids=${fcyIds}`
    const response = apiGetHelper(URL, false, requestHeaders)
    return response
}
export const DebugViewApi = () => {
    let url = `${DOMAIN}/hotels/debug-view`
    const response = apiGetHelper(url)
    return response
}

export const HotelDetailsGql = (query, hotelId, checkIn, checkOut, roomAllocations, metadata) => {
    const response = useQuery(query, {
        variables: {
            id: hotelId,
            chkIn: checkIn,
            chkOut: checkOut,
            roomAllocations: roomAllocations,
            metadata: metadata
        },
        notifyOnNetworkStatusChange: true,
        skip: !hotelId || !checkIn || !checkOut || !roomAllocations,
        fetchPolicy: 'no-cache'
    })
    return response
}

export const getHotelConfirmation = (itinId) => {
    const url = `${getPlatformApiDomain()}/hotel/orchestrator/v2/itinerary/${itinId}/confirmation`
    const requestHeaders = {
        'x-client-id': 'CT',
        'x-source-type': 'ct_desktop',
        'x-cookie': document.cookie,
    }
    const response = apiGetHelper(url, 'application/json',requestHeaders)
    return response
}

export const getAbTestConfig = () => {
    const url = `${DOMAIN}/source/abtest/getabtestconfig`
    const response = apiGetHelper(url);
    return response
}

// export const HotelDetailsGqlMutation = (query, hotelId, checkIn, checkOut, roomAllocations, metadata) => {
//     const response = useLazyQuery(query)
//     return response
// }

export const localityAutoSugggest = payload => {
    const domain = getPlatformApiDomain()
    const URL = `${domain}/prefixy/maps/v2/suggestions?city=${payload.city}&input=${payload.str}&cityId=${payload.cityId}`
    const requestHeaders = {
        source: 'ct-hotels',
        withCredential: false,
        'x-cookie': document && document.cookie
    }
    const response = apiGetHelper(URL, {}, requestHeaders)
    return response
}

export const localityAutoSugggestLatLng = payload => {
    const domain = getPlatformApiDomain()
    const URL = `${domain}/prefixy/maps/location?city=${payload.city}&input=${payload.str}`
    const requestHeaders = {
        source: 'ct-hotels',
        withCredential: false,
        'x-cookie': document && document.cookie
    }
    const response = apiGetHelper(URL, {}, requestHeaders)
    return response
}
